export const FAQ_URL = 'https://www.woah.org/en/document/wildepi-qa/';
export const ABOUT_URL =
  'https://www.woah.org/en/document/charterandgovernance/';
export const SUPPORT_EMAIL = 'wildlife@woah.org';
